//Import OwlCarousel
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import 'owl.carousel';

//Import external functions
import { coverageAjax } from './coverage_block-ajax';
import { sidebarMenu } from './sidebar_menu_ajax';
import { taxTermsHome } from './taxonomy_block_ajax';
import { coverageDetailAjax } from './coverage_detail_block';
import { AjaxLoadMore } from './ajax-loadMore';
import { PeopleOnLoad, peopleListFiltering, AjaxLoadPeople } from './people_ajax';
import { carouselCustomPosts, listCustomPosts } from './custom_post_block_ajax';
import { focusGroupTemplate, focusGroupRelatedTemplate } from './focus_group_expertise';
import { registrationMailup } from './ajax_mailup';
import { InsightsOnLoad, insightsListFiltering, AjaxLoadInsights } from './insights_ajax';
import { JobsOnLoad, jobsListFiltering, AjaxLoadJobs } from './ajax_jobs';
import { SearchResultsFilter } from './search_filters_ajax';
import { earthJS } from './earth_script';

(function($) {
    $(document).ready(function(){

        //Sidebar Ajax
        new sidebarMenu();

        new coverageAjax();

        new taxTermsHome();

        new coverageDetailAjax();

        new AjaxLoadMore();

        new PeopleOnLoad();

        new peopleListFiltering();

        new AjaxLoadPeople();

        new InsightsOnLoad();

        new insightsListFiltering();

        new AjaxLoadInsights();

        new JobsOnLoad();

        new jobsListFiltering();

        new AjaxLoadJobs();

        new focusGroupTemplate();

        new registrationMailup();

        new focusGroupRelatedTemplate();

        new SearchResultsFilter();

        let heroHome = $('.hero_home_container');
        if(heroHome){
            let h1 = $('.hero_home_container .text_col h1');
            let h2 = $('.hero_home_container .text_col h2');
            let h3 = $('.hero_home_container .text_col h3');
            h1.css({
                'transform' : 'translateX(0%)',
                'opacity' : 1,
                'transition': 'all ease 0.6s'
            });
            setInterval(function(){
                h2.css({
                    'transform' : 'translateX(0%)',
                    'opacity' : 1,
                    'transition': 'all ease 0.8s'
                });
            }, 800)
            setInterval(function(){
                h3.css({
                    'transform' : 'translateX(0%)',
                    'opacity' : 1,
                    'transition': 'all ease 1s'
                });
            }, 1600)
        }

        let newSearchBtn = $('.new_search');
        if(newSearchBtn.length > 0){
            newSearchBtn.on('click', function(e){
                e.preventDefault();
                $('.search_input').slideToggle();
            })
            $('.close_icon_search').click(function(){
                $('.search_input').slideToggle();
            })
        }

        let headerSearchBtn = $('.header_search_action > a');
        if(headerSearchBtn.length > 0){
            headerSearchBtn.on('click', function(e){
                e.preventDefault();

                var slideWidth = $('.menu_search').outerWidth();
    
                // Animazione per far apparire la slide da destra
                $('.header_search').css({
                  'display': 'block',
                  'position': 'absolute',
                  'right': '-' + slideWidth + 'px'
                }).animate({ 'right': '0px' }, 500);
                //$('.header_search').slideToggle();
            })
            $('.close_icon').click(function(){
                var slideWidth = $('.header_search').outerWidth();

                // Animazione per chiudere la slide verso sinistra
                $('.header_search').animate({ 'right': '-' + slideWidth + 'px' }, 500, function() {
                  // Al termine dell'animazione, reimposta il display a none
                  $(this).css('display', 'none');
                });
                //$('.header_search').slideToggle();
            })
        }



        //new TagSearch();

        // Funzione per gestire il ridimensionamento della finestra
        function handleResize() {
            new focusGroupTemplate();
            new focusGroupRelatedTemplate();
            if ($(window).width() < 1281) {
                // Larghezza inferiore a 900px: nascondi elementi o cambia layout
                $('.desktop_element').hide();
                $('.mobile_element').show();
                $('.offcanvas ').addClass('offcanvas_mobile');
                new carouselCustomPosts();

                let headerSearchBtn = $('.header_search_action > a');
                if(headerSearchBtn.length > 0){
                    headerSearchBtn.on('click', function(e){
                        e.preventDefault();

                        var slideWidth = $('header').outerWidth();
            
                        // Animazione per far apparire la slide da destra
                        $('.header_search').css({
                        'display': 'block',
                        'position': 'fixed',
                        'max-width' : '90%',
                        'right': '-' + slideWidth + 'px'
                        }).animate({ 'right': '0px' }, 500);
                        //$('.header_search').slideToggle();
                    })
                    $('.close_icon').click(function(){
                        var slideWidth = $('.header_search').outerWidth();

                        // Animazione per chiudere la slide verso sinistra
                        $('.header_search').animate({ 'right': '-' + slideWidth + 'px' }, 500, function() {
                        // Al termine dell'animazione, reimposta il display a none
                        $(this).css('display', 'none');
                        });
                        //$('.header_search').slideToggle();
                    })
                }
                // Aggiungi qui il tuo codice per adattare il layout al ridimensionamento
            } else {
                // Larghezza maggiore o uguale a 900px: ripristina o cambia layout
                $('.desktop_element').show();
                $('.mobile_element').hide();
                $('.offcanvas ').removeClass('offcanvas_mobile');
                new listCustomPosts();
                // Aggiungi qui il tuo codice per adattare il layout al ridimensionamento
            }
        }
    
        // Esegui la funzione all'avvio del documento
        handleResize();
    
        // Attiva la funzione quando la finestra viene ridimensionata
        $(window).resize(function() {
            handleResize();
        });

        $('#menu-menu-in-sidebar li a').click(function(e) {
            if($(this).closest('li').hasClass('has_menu_shortcode')){
                $(this).addClass('active_menu');
                $('#menu-menu-in-sidebar li a').not(this).removeClass('active_menu');
                //$('#menu-menu-in-sidebar li').removeClass('current-menu-item');
                if ($(window).width() < 1281) {
                    $('.offcanvas_mobile .right_content').show();
                }else{
                    $('.offcanvas_mobile .right_content').hide();
                }
            }
        })
        $('.offcanvas-header button.btn-close').click(function(){
            $('#menu-menu-in-sidebar li a').removeClass('active_menu');
            if ($(window).width() < 1281) {
                $('.offcanvas_mobile .right_content').hide();
            }
        })

        //Initialize selects
        $('.slect2_custom_select').select2();
        //Multiple select
        $('.slect2_custom_multiple_select').select2({
            placeholder: function() {
                return $(this).data('placeholder');
            },
            closeOnSelect: false, // Imposta l'opzione per mantenere aperto il dropdown
            allowClear: true,
            dropdownCssClass: 'multiple_select_dropdown',
        });

        $('.keep_in_touch_container form#keep_in_touch_form .slect2_custom_multiple_select').on('select2:open', function() {
            // Codice da eseguire quando il dropdown di Select2 viene aperto
            $('.keep_in_touch_container form#keep_in_touch_form .slect2_custom_multiple_select').addClass('custom_open');
            console.log('Select2 dropdown aperto');
        });
        $('.keep_in_touch_container form#keep_in_touch_form .slect2_custom_multiple_select').on('select2:close', function() {
            // Codice da eseguire quando il dropdown di Select2 viene aperto
            $('.keep_in_touch_container form#keep_in_touch_form .slect2_custom_multiple_select').removeClass('custom_open');
            console.log('Select2 dropdown chiuso');
        });

        //Hero home articles carousel
        let home_articles_carousel = $('#hero_articles_carousel');
        if(home_articles_carousel.length > 0){
            $('#hero_articles_carousel').owlCarousel({
                loop:true,
                items:1,
                margin:5,
                dots:true,
                nav:false,                
                autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true,
            })
        }

        //Gallery carousel
        let gallery_carousel = $('#gallery_carousel');
        if(gallery_carousel.length > 0){
            $('#gallery_carousel').owlCarousel({
                loop:false,
                items:3,
                margin:16,
                dots:true,
                nav:false,
                responsive:{
                    0:{
                        items:1,
                        nav:false
                    },
                    600:{
                        items:1,
                        nav:false
                    },
                    1300:{
                        items:3,
                        nav:false
                    }
                }
            })
        }


        //Numbers_mobile_carousel
        let numbers_carousel = $('#numbers_carousel');
        if(numbers_carousel.length > 0){
            $('#numbers_carousel').owlCarousel({
                loop:false,
                items:3,
                margin:20,
                dots:true,
                nav:false,                
                responsive:{
                    0:{
                        items:1,
                        nav:false
                    },
                    600:{
                        items:1,
                        nav:false
                    },
                    1300:{
                        items:3,
                        nav:false
                    }
                }
            })
        }

        //Home taxonomy carousel
        let terms_carousel_home = $('#terms_home_carousel');
        if(terms_carousel_home.length > 0){
            $('#terms_home_carousel').owlCarousel({
                loop:false,
                items:1,
                margin:20,
                dots:true,
                nav:false,
            })
        }

        //Insights carousel
        let insights_carousel = $('#insights_carousel');
        if(insights_carousel.length > 0){
            $('#insights_carousel').owlCarousel({
                loop:true,
                margin:16,
                dots:true,
                nav:false,
                autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true,
                responsive:{
                    0:{
                        items:1,
                        nav:false
                    },
                    900:{
                        items:3,
                        nav:false
                    },
                    1300:{
                        items:3,
                        nav:false
                    }
                }
            })
        }

        //Menu taxonomy carousel
        // let terms_carousel = $('#terms_menu_carousel');
        // if(terms_carousel.length > 0){
        //     $('#terms_menu_carousel').owlCarousel({
        //         loop:false,
        //         items:1,
        //         margin:20,
        //         dots:true,
        //         nav:false,
        //     })

        //     if($('#pills-tab-menuContent .custom-dots-container').hasClass('disabled')){
        //         $('#pills-tab-menuContent .navs-container').hide();
        //     }else{
        //         $('#pills-tab-menuContent .navs-container').show();
        //     }
        // }

        //Peoples carousel
        let peoples_carousel = $('#ajax_content_coverage_people');
        if(peoples_carousel.length > 0){
            $('#ajax_content_coverage_people').owlCarousel({
                loop:false,
                items:1,
                margin:5,
                dots:true,
                nav:false,
                // Posiziona i puntini nel loro container
                dotsContainer: '.custom-dots-container'
            })
            // Aggiungi manualmente i pulsanti 'prev' e 'next' nei rispettivi container
            let owlInstance = $('#ajax_content_coverage_people').data('owl.carousel');

            $('.coverage_peoples_block .custom-prev-container span').on('click', function () {
                owlInstance.prev();
            });

            $('.coverage_peoples_block .custom-next-container span').on('click', function () {
                owlInstance.next();
            });

            if($('.coverage_peoples_block .custom-dots-container').hasClass('disabled')){
                $('.coverage_peoples_block .navs-container').hide();
            }else{
                $('.coverage_peoples_block .navs-container').show();
            }
        }

        //About us carousels
        let about_first_carousel = $('#about_first_carousel');
        if (about_first_carousel.length > 0) {
            let prevIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="17" viewBox="0 0 30 17" fill="none"><path d="M5.64645 9.35355C5.45119 9.15829 5.45119 8.84171 5.64645 8.64645L8.82843 5.46447C9.02369 5.2692 9.34027 5.2692 9.53553 5.46447C9.7308 5.65973 9.7308 5.97631 9.53553 6.17157L6.70711 9L9.53553 11.8284C9.7308 12.0237 9.7308 12.3403 9.53553 12.5355C9.34027 12.7308 9.02369 12.7308 8.82843 12.5355L5.64645 9.35355ZM30 9.5H6V8.5H30V9.5Z" fill="#899DA4"/></svg>';
            let nextIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="17" viewBox="0 0 30 17" fill="none"><path d="M24.3536 9.35355C24.5488 9.15829 24.5488 8.84171 24.3536 8.64645L21.1716 5.46447C20.9763 5.2692 20.6597 5.2692 20.4645 5.46447C20.2692 5.65973 20.2692 5.97631 20.4645 6.17157L23.2929 9L20.4645 11.8284C20.2692 12.0237 20.2692 12.3403 20.4645 12.5355C20.6597 12.7308 20.9763 12.7308 21.1716 12.5355L24.3536 9.35355ZM0 9.5H24V8.5H0V9.5Z" fill="#899DA4"/></svg>'
            about_first_carousel.owlCarousel({
                loop: true,
                items: 1,
                margin: 25,
                dots: false,
                nav: true,
                // Aggiungi la funzione di callback per prepopolare le frecce
                onInitialized: function (event) {
                    // Ottieni il titolo del prossimo e del precedente post
                    let nextTitle = $(event.target).find('.owl-item.active').next().find('.text_container .title h2 p').text();
                    let prevTitle = $(event.target).find('.owl-item.active').prev().find('.text_container .title h2 p').text();

                    // Aggiorna il testo delle frecce con i titoli
                    $('#about_first_carousel .owl-next').html(nextTitle + nextIcon);
                    $('#about_first_carousel .owl-prev').html(prevIcon + prevTitle);
                },
                onTranslate: function (event) {
                    // Ottieni l'indice dell'elemento corrente
                    let currentIndex = event.item.index;
                
                    // Ottieni il titolo del prossimo e del precedente post
                    let nextTitle = $(event.target).find('.owl-item').eq(currentIndex + 1).find('.text_container .title h2 p').text();
                    let prevTitle = $(event.target).find('.owl-item').eq(currentIndex - 1).find('.text_container .title h2 p').text();
                
                    // Aggiorna il testo delle frecce con i titoli
                    $('#about_first_carousel .owl-next').html(nextTitle + nextIcon);
                    $('#about_first_carousel .owl-prev').html(prevIcon + prevTitle);
                }
            });
        }
        let about_second_carousel = $('#about_second_carousel');
        if (about_second_carousel.length > 0) {
            let prevIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="17" viewBox="0 0 30 17" fill="none"><path d="M5.64645 9.35355C5.45119 9.15829 5.45119 8.84171 5.64645 8.64645L8.82843 5.46447C9.02369 5.2692 9.34027 5.2692 9.53553 5.46447C9.7308 5.65973 9.7308 5.97631 9.53553 6.17157L6.70711 9L9.53553 11.8284C9.7308 12.0237 9.7308 12.3403 9.53553 12.5355C9.34027 12.7308 9.02369 12.7308 8.82843 12.5355L5.64645 9.35355ZM30 9.5H6V8.5H30V9.5Z" fill="#899DA4"/></svg>';
            let nextIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="17" viewBox="0 0 30 17" fill="none"><path d="M24.3536 9.35355C24.5488 9.15829 24.5488 8.84171 24.3536 8.64645L21.1716 5.46447C20.9763 5.2692 20.6597 5.2692 20.4645 5.46447C20.2692 5.65973 20.2692 5.97631 20.4645 6.17157L23.2929 9L20.4645 11.8284C20.2692 12.0237 20.2692 12.3403 20.4645 12.5355C20.6597 12.7308 20.9763 12.7308 21.1716 12.5355L24.3536 9.35355ZM0 9.5H24V8.5H0V9.5Z" fill="#899DA4"/></svg>'
            about_second_carousel.owlCarousel({
                loop: true,
                items: 1,
                margin: 25,
                dots: false,
                nav: true,
                // Aggiungi la funzione di callback per prepopolare le frecce
                onInitialized: function (event) {
                    // Ottieni il titolo del prossimo e del precedente post
                    let nextTitle = $(event.target).find('.owl-item.active').next().find('.text_container .title h2 p').text();
                    let prevTitle = $(event.target).find('.owl-item.active').prev().find('.text_container .title h2 p').text();

                    // Aggiorna il testo delle frecce con i titoli
                    $('#about_second_carousel .owl-next').html(nextTitle + nextIcon);
                    $('#about_second_carousel .owl-prev').html(prevIcon + prevTitle);
                },
                // Aggiungi la funzione di callback per personalizzare le frecce
                onTranslate: function (event) {
                    // Ottieni l'indice dell'elemento corrente
                    let currentIndex = event.item.index;
                
                    // Ottieni il titolo del prossimo e del precedente post
                    let nextTitle = $(event.target).find('.owl-item').eq(currentIndex + 1).find('.text_container .title h2 p').text();
                    let prevTitle = $(event.target).find('.owl-item').eq(currentIndex - 1).find('.text_container .title h2 p').text();
                
                    // Aggiorna il testo delle frecce con i titoli
                    $('#about_second_carousel .owl-next').html(nextTitle + nextIcon);
                    $('#about_second_carousel .owl-prev').html(prevIcon + prevTitle);
                }
            });
        }

        let aboutBlock = $('.about_block .content');
        if ($(window).width() > 1281 && aboutBlock.length > 0) {
            let marginLeft = $('.about_block .content').offset().left;
            $('.taxonomy_content_container').css('margin-left', marginLeft);
        }
        $(window).resize(function() {
            if ($(window).width() < 1281) {
                $('.taxonomy_content_container').css('margin-left', 0);
            }
            if ($(window).width() > 1281 && aboutBlock.length > 0) {
                let marginLeft = $('.about_block .content').offset().left;
                $('.taxonomy_content_container').css('margin-left', marginLeft);
            }
        })

        let tabs_mobile = $('.mobile_tabs_select');
        if(tabs_mobile.length > 0){
            $('.mobile_tabs_select').change(function(){
                let seleted = $(this).find('option:selected');
                let dataCustomValue = seleted.data('tab-id');
                console.log(dataCustomValue);
                $('.nav-pills').find('#' + dataCustomValue).trigger('click');
            })
        }

        //Expertise competence carousel
        let expertise_competence = $('#expertise_competence_carousel');
        if(expertise_competence.length > 0){
            $('#expertise_competence_carousel').owlCarousel({
                loop:false,
                items:1,
                margin:20,
                dots:true,
                nav:false, // Posiziona i puntini nel loro container
                dotsContainer: '.custom-dots-container'
            })
            // Aggiungi manualmente i pulsanti 'prev' e 'next' nei rispettivi container
            let owlInstance = $('#expertise_competence_carousel').data('owl.carousel');

            $('.expertise_competence_container .custom-prev-container span').on('click', function () {
                owlInstance.prev();
            });

            $('.expertise_competence_container .custom-next-container span').on('click', function () {
                owlInstance.next();
            });

            if($('.expertise_competence_container .custom-dots-container').hasClass('disabled')){
                $('.expertise_competence_container .navs-container').hide();
            }else{
                $('.expertise_competence_container .navs-container').show();
            }
        }

        let fileInput = $('input[type="file"]');
        if(fileInput.length > 0){
            // Quando l'input file cambia
            $('input[type="file"]').change(function(e) {
                // Ottieni il nome del file selezionato
                var nomeFile = e.target.files[0].name;
                
                let inputContainer = $(this).closest('.file_input');
                inputContainer.find('.filename_container').text(nomeFile);
                console.log(nomeFile);
                // Mostra il nome del file in un paragrafo
                //$('#nome-file-selezionato').text('Nome del file: ' + nomeFile);
            });
        }

        $

        $('.wpcf7-form').on('submit', function() {
            document.addEventListener('wpcf7mailsent', function(event) {
                // Il form è stato inviato con successo
                console.log('Form inviato con successo');
                let inputContainer = $(this).find('.filename_container').text('');
            }, false);
            document.addEventListener('wpcf7invalid', function(event) {
                // Il form contiene campi non validi
                console.log('Form contiene campi non validi');
            }, false);

           
        })

        //Numbers animation
        // Creare un observer per il div business block
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const $numeroContainer = $(entry.target);
                    const $numeroBlocco = $numeroContainer.find('.number h1');
                    const countTo = parseInt($numeroBlocco.text(), 10);
                    
                    // Avvia l'animazione solo se non è già stata avviata
                    if (!$('.business_block_container').hasClass('animated')) {
                        $('.number h1').each(function() {
                            var $this = $(this);
                            var countTo = parseInt($this.text(), 10);
                            $({ countNum: 1 }).animate({
                                countNum: countTo
                            }, {
                                duration: 2500, // Durata dell'animazione in millisecondi
                                easing: 'swing', // Effetto di easing dell'animazione
                                step: function() {
                                    $this.text(Math.floor(this.countNum));
                                },
                                complete: function() {
                                    $this.text(this.countNum);
                                }
                            });
                
                            //stesso timing
                            // var $this = $(this);
                            // var countTo = parseInt($this.text(), 10);
                            // var duration = 3500; // Durata di default dell'animazione
                
                            // // Calcola la durata in base al numero all'interno del blocco
                            // var difference = countTo - 1;
                            // if (difference > 0) {
                            //     duration = 3500 * difference / 100;
                            // }
                
                            // $({ countNum: 1 }).animate({
                            //     countNum: countTo
                            // }, {
                            //     duration: duration, // Durata dell'animazione calcolata
                            //     easing: 'swing', // Effetto di easing dell'animazione
                            //     step: function() {
                            //         $this.text(Math.floor(this.countNum));
                            //     },
                            //     complete: function() {
                            //         $this.text(this.countNum);
                            //     }
                            // });
                        });
                        $('.business_block_container').addClass('animated');
                    }
                }
            });
        }, { threshold: 0.5 }); // Il div entra nel viewport quando il 50% è visibile

        // Aggiungi ogni business block all'observer
        $('.business_block_container').each(function() {
            observer.observe(this);
        });

        new earthJS();

        //Parameters for scroll
        let urlParams = new URLSearchParams(window.location.search);

        // Ottieni il valore del parametro 'anchor'
        let targetHash = urlParams.get('anchor');
        
        let decodedHash = decodeURIComponent(targetHash);
        if (decodedHash && decodedHash.endsWith('/')) {
            decodedHash = decodedHash.slice(0, -1); // Rimuovi l'ultimo carattere
        }

        // Controlla se è presente un valore di 'anchor'
        if (decodedHash) {
            // Attendi 1 secondo prima di eseguire lo scroll
            setTimeout(function() {
                // Fai lo scroll fino all'elemento con l'id corrispondente utilizzando jQuery
                let targetElement = $('#' + decodedHash);
                if (targetElement.length) {
                    $('html, body').animate({
                        scrollTop: targetElement.offset().top
                    }, 500); // Durata dell'animazione in millisecondi (1 secondo)
                }
            }, 100); // 1000 millisecondi = 1 secondo
        }

        //Back to top
        jQuery(document).ready(function($) {
            var backToTopButton = $('#back-to-top');
        
            $(window).on('scroll', function() {
                if ($(window).scrollTop() > 1500) {
                    backToTopButton.fadeIn();
                    backToTopButton.css('display', 'flex');
                } else {
                    backToTopButton.fadeOut();
                }
            });
        
            backToTopButton.on('click', function(event) {
                event.preventDefault();
                $('html, body').animate({ scrollTop: 0 }, 'smooth');
            });
        });

    });
})(jQuery);